import { create } from 'zustand';

/**
 * Lets Partnr canvas actions ask the user before doing something destructive
 * or costly (e.g. a paid extension run).
 * The executor awaits `ask()`; PartnrConfirmDialog renders the pending request
 * and resolves it with the user's answer.
 */
export interface PartnrConfirmRequest {
  title: string;
  description: string;
  items: string[];
  confirmLabel: string;
  /** Red confirm button. Defaults to true (deletes); false for non-destructive asks like a paid run. */
  destructive?: boolean;
}

interface PartnrConfirmState {
  request: (PartnrConfirmRequest & { resolve: (confirmed: boolean) => void }) | null;
  ask: (request: PartnrConfirmRequest) => Promise<boolean>;
  answer: (confirmed: boolean) => void;
}

export const usePartnrConfirmStore = create<PartnrConfirmState>((set, get) => ({
  request: null,

  ask: (request) =>
    new Promise<boolean>((resolve) => {
      // A newer request replaces an unanswered one, which counts as "no".
      get().request?.resolve(false);
      set({ request: { ...request, resolve } });
    }),

  answer: (confirmed) => {
    const pending = get().request;
    set({ request: null });
    pending?.resolve(confirmed);
  },
}));
